import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FacebookProvider, ShareButton } from 'react-facebook';

const setMetrics = setMetricsEvent => (label, action) => {
  const eventCategory = 'vcard';
  const eventAction = action;
  const eventLabel = label;

  setMetricsEvent({
    tagManager: {
      event: 'click',
      eventCategory,
      eventAction,
      eventLabel,
    },
  });

  setMetricsEvent({
    type: 'executor',
    success: true,
  });
};

function Share({ appID, locale, urlToShare, btnLabelShare, propsCard }) {
  return (
    <FacebookProvider appID={appID} language={locale}>
      <ShareButton
        href={urlToShare}
        icon={false}
        className="btn btn-default btn-lg"
      >
        {
          <div
            onClick={() => {
              let eventLabel;
              let eventAction;
              let genero = null;
              const groupResult = propsCard.groupResult;
              const queryParams = {
                title: propsCard.data.title,
                titleUri: propsCard.data.titleUri,
              };
              if (propsCard.contentData.extendedcommon.genres) {
                genero =
                  propsCard.contentData.extendedcommon.genres.genre[0].desc;
                queryParams.genero = genero;
              }
              let type = propsCard.contentData.extendedcommon.format.sell_type;
              if (type == 'susc') {
                type =
                  propsCard.contentData.extendedcommon.media.proveedor.nombre;
                if (type == 'AMCO') type = 'susc';
              }

              eventAction = 'Compartir Facebook';
              if (propsCard.seriesData !== null) {
                const nameSerie =
                  propsCard.groupResult.extendedcommon.media.serie.title;
                eventLabel = `${queryParams.genero} - ${nameSerie} | ${
                  propsCard.groupResult.title
                } - ${type}`;
              } else {
                eventLabel = `${queryParams.genero} - ${
                  groupResult.title
                } - ${type}`;
              }
              setMetrics(propsCard.setMetricsEvent)(eventLabel, eventAction);
            }}
          >
            {btnLabelShare}
          </div>
        }
      </ShareButton>
    </FacebookProvider>
  );
}

Share.propTypes = {
  btnLabelShare: PropTypes.string,
  propsCard: PropTypes.object,
  locale: PropTypes.string,
  urlToShare: PropTypes.string,
  appID: PropTypes.string,
  onClick: PropTypes.func,
  groupResult: PropTypes.object,
  params: PropTypes.object,
};

const mapStateToProps = state => ({
  contentData: state.card.contentData,
  groupResult: state.card.contentData,
  seriesData: state.card.seriesData,
});

export default connect(mapStateToProps)(Share);
